import React, { Component } from 'react';
import { UsersService } from '../../services/user';
import './termos-de-uso.css';

import {
  HeaderShelf,
  SidebarRoundedIcons,
  Footer
} from '../../components';

export default class ViewTermosDeUso extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      isUserLoggedIn: false
    };
  }

  componentDidMount() {
    const user = UsersService.getUser();
    this.setState({ isUserLoggedIn: user !== null });
  }

  onBack() {
    window.location = window.location.origin + window.location.pathname + "#/";
  }

  async signOut() {
    await UsersService.signOut()
    window.location = window.location.origin + window.location.pathname + "#/login";
  }

  render() {
    const { loading, isUserLoggedIn } = this.state;
    
    if (loading) {
      return (
        <div className="rdp-react-template-view-termos-de-uso">
          <div className="rdp-react-template-view-termos-de-uso-loading">
            <div className="rdp-react-template-view-termos-de-uso-loader"></div>
          </div>
        </div>
      );
    }

    return (
      <div className="rdp-react-template-view-termos-de-uso">
        <div className="rdp-react-template-view-termos-de-uso-header">
          <HeaderShelf
            onSignOut={() => this.signOut()}
            renderSearch={false}
            isUserLoggedIn={isUserLoggedIn}
          />
        </div>

        {isUserLoggedIn && (
          <div className="rdp-react-template-view-termos-de-uso-sidebar">
            <SidebarRoundedIcons />
          </div>
        )}

        <div className="rdp-react-template-view-termos-de-uso-main">
          <div className="rdp-react-template-view-termos-de-uso-container">
            <div className="rdp-react-template-view-termos-de-uso-header-section">
              <h1 className="rdp-react-template-view-termos-de-uso-title">Termos de uso</h1>
            </div>

            <div className="rdp-react-template-view-termos-de-uso-content">
              <div className="rdp-react-template-view-termos-de-uso-main-title">
                Termos e Condições de Uso da Biblioteca Digital Senac
              </div>

              <div className="rdp-react-template-view-termos-de-uso-text">
                <p>
                  O conteúdo da Biblioteca Digital Senac é comercializado pela
                  Editora Senac São Paulo ("Editora"). A Editora é uma
                  unidade do Senac – Serviço Nacional de Aprendizagem
                  Comercial – criada em 1995, situada na Rua 24 de Maio, 208
                  – 3º andar – República – São Paulo/SP, CNPJ nº.
                  03.709.814/0040-02, site
                  http://www.editorasenacsp.com.br/.
                </p>
                <p>
                  O acesso a qualquer um dos conteúdos constantes na
                  Biblioteca Digital Senac acarreta a condição de "Usuário
                  da Base" (ou "Usuário") e implica a aceitação e
                  concordância dos termos aqui estipulados.
                </p>
                <p>
                  Os Termos e Condições de Uso (os "Termos") estabelecem as
                  regras para o uso da Biblioteca Digital Senac, e a
                  utilização do software de leitura (incluindo qualquer
                  documentação associada e quaisquer atualizações para esse
                  software), o qual permitirá a leitura do conteúdo digital
                  e que será disponibilizado para download na base ou na
                  loja de aplicativos (respectivamente "Software",
                  "Conteúdo" e também "Produtos").
                </p>
                <p>
                  A Editora disponibilizará o acesso aos Conteúdos da Base
                  aos Usuários, ficando estabelecido que os Usuários são
                  sempre vinculados a uma Instituição ou Empresa assinante
                  (“Clientes institucionais assinantes”) dos produtos de
                  titularidade da Editora.
                </p>
                <p>
                  A Editora licencia aos seus “Clientes institucionais
                  assinantes” e “Usuários” qualquer produto para download,
                  mas não para venda. A Editora permanece como proprietária
                  de todos os Produtos, assim como de seus direitos
                  autorais, ininterruptamente.
                </p>
                <p>
                  Todos os direitos de propriedade intelectual em qualquer
                  conteúdo da Base são de propriedade da Editora Senac São
                  Paulo. “Clientes institucionais assinantes” e/ou
                  “Usuários” reconhecem que não adquirem nenhum direito de
                  propriedade sobre qualquer conteúdo ao fazer o download do
                  site ou por meio ou não de aplicativos (apps).
                </p>
                <p>
                  A Editora se reserva o direito de alterar estes Termos
                  ocasionalmente. Aos Usuários da Base é recomendado
                  consultá-los periodicamente para verificar quaisquer
                  alterações ou atualizações realizadas.
                </p>
                <p>
                  <strong>
                    Estes Termos foram atualizados pela última vez em 25 de
                    março de 2019.
                  </strong>
                </p>

                <h2>1. Licença e Uso</h2>
                <p>
                  1.1 Todos os “Clientes institucionais assinantes” possuem
                  um pacote de licenças limitado, não exclusivo e
                  intransferível para “Clientes institucionais”, para
                  acessar a Base e qualquer Produto. Todos os “Clientes
                  institucionais assinantes” podem determinar os “Usuários”
                  que recebem licenças individuais para seu uso pessoal.
                  Qualquer uso comercial ou que viole estes Termos ou ainda
                  que seja feito para a coleta de dados e/ou lucro não é
                  permitido.
                </p>
                <p>
                  1.2 Cada Usuário pode recuperar e exibir conteúdo do Base
                  ou de qualquer Produto em um computador ou outro
                  dispositivo, além de armazenar essas páginas em formato
                  eletrônico nesse dispositivo.
                </p>
                <p>
                  1.3 Cada Usuário só deve usar a Base ou Produto e qualquer
                  item disponível na Base ou em um Produto para propósitos
                  legais (cumprindo todas as leis e regulamentações
                  aplicáveis), de maneira responsável, e não de uma maneira
                  que possa prejudicar a Editora, o Senac ou sua reputação
                  ou a de qualquer um dos nossos afiliados.
                </p>
                <p>
                  1.4 É proibida a impressão e/ou a cópia de páginas
                  individuais ou em grupo, de forma impressa ou digital.
                </p>
                <p>
                  1.5 É proibido o armazenamento de páginas individuais, ou
                  em grupo, de forma digital fora dos canais de distribuição
                  autorizados.
                </p>

                <h2>2. Acesso ao Conteúdo da Base e Produtos</h2>
                <p>
                  2.1. É considerado conteúdo da Base todo e qualquer
                  conteúdo, aplicativo e ferramenta, disponibilizados e/ou
                  veiculados pela Editora na Base para utilização por
                  qualquer pessoa que acessar tais conteúdos (o “Usuário”).
                </p>
                <p>
                  2.2. A Editora disponibilizará o acesso aos Conteúdos da
                  Base aos Usuários, ficando estabelecido que os Usuários
                  são sempre vinculados a Editora ou a uma Instituição ou
                  Empresa assinante (“Clientes institucionais assinantes”)
                  dos produtos de titularidade da Editora.
                </p>
                <p>
                  2.3. Os usuários, portanto, devem cumprir as condições
                  previstas no contrato celebrado entre a Editora e os
                  clientes institucionais assinantes.
                </p>
                <p>
                  2.4. Os Usuários, vinculados a “Clientes institucionais
                  assinantes” dos Produtos da Editora terão acesso
                  ilimitado(a) e gratuito aos conteúdos contratados da Base,
                  bastando apenas realizar o login na Base ou em sua
                  Instituição vinculada.
                </p>
                <p className="senac_sublegend">
                  (a) O acesso ilimitado está vinculado à política de acesso
                  estabelecida pelos “Clientes institucionais assinantes”.
                </p>
                <p>
                  2.5. O Usuário deverá utilizar equipamento próprio, ou da
                  Instituição a que se vincula, para acessar a Base, não
                  sendo a Editora responsável por qualquer impossibilidade
                  de acesso individual ou local, ou até mesmo por
                  incompatibilidade da Base com qualquer equipamento,
                  sistema utilizado pelo Usuário e/ou configurações de
                  software e hardware utilizados pelo Usuário.
                </p>
                <p>
                  2.6. A seleção de discador, provedor e/ou outro meio de
                  acesso à Internet e os custos inerentes são unicamente de
                  responsabilidade do Usuário.
                </p>
                <p>
                  2.7. Para identificação do Usuário durante o acesso à
                  Base, a Editora poderá utilizar arquivos temporários
                  (cookies), devendo ser observado, ainda, o disposto na
                  cláusula de Privacidade abaixo.
                </p>
                <p>
                  2.8. A Editora reserva o direito de retirar ou suspender a
                  operação de qualquer Produto ou do Site, com ou sem aviso
                  prévio, desde que por motivos legais ou de segurança.
                </p>

                <h2>3. Cadastro do Usuário, Senha e Segurança</h2>
                <p>
                  3.1. Para que o Usuário possa acessar os Conteúdos da Base
                  anteriormente mencionados, o “Cliente institucional
                  assinante” deverá fornecer aos Usuários login e senha para
                  acesso ao Conteúdo da Base.
                </p>
                <ul>
                  <li>
                    O login e a senha fornecidos para cada Usuário são
                    individuais, pessoais e intransferíveis.
                  </li>
                </ul>
                <p>
                  3.2. A Editora poderá solicitar que o Usuário realize
                  prévio cadastro (o “Cadastro”), no qual poderão ser
                  solicitados dados pessoais (os “Dados do Usuário”).
                </p>
                <p>
                  3.3. O Usuário, neste Termo de Uso, concorda em:
                </p>
                <ul>
                  <li>
                    fornecer informações verdadeiras, exatas, atuais e
                    completas sobre si mesmo quando do registro no cadastro
                    específico para acesso aos Conteúdos da Base;
                  </li>
                  <li>
                    conservar e atualizar imediatamente tais informações do
                    Cadastro para mantê-las verdadeiras, exatas, atuais e
                    completas.
                  </li>
                </ul>
                <p>
                  3.4. O Usuário deverá informar seu próprio endereço
                  eletrônico a ser utilizado para sua identificação na
                  Biblioteca Digital Senac e para o recebimento de mensagens
                  advindas de seu cadastro na referida Base. O Usuário
                  deverá também criar uma senha, sendo inteiramente
                  responsável pela confidencialidade dela, bem como de
                  qualquer atividade que ocorra no âmbito de seu Cadastro. O
                  Usuário pode alterar sua senha a qualquer momento. Tanto o
                  endereço eletrônico informado pelo Usuário quanto a senha
                  por ele criada serão utilizados para a sua identificação e
                  permissão de acesso à Base.
                </p>
                <p>
                  3.5. Usuários menores de 18 (dezoito) anos ou
                  juridicamente incapazes precisam ser representados ou
                  assistidos, conforme o caso, por seus pais ou responsáveis
                  legais para fazer o Cadastro
                </p>
                <p>
                  3.6. Os dados do Usuário serão protegidos por senha para
                  sua segurança e privacidade.
                </p>
                <p>
                  3.7. O Usuário concorda em notificar imediatamente a
                  Editora sobre qualquer uso não autorizado de seu login
                  (identificação do Usuário para acesso à Base mediante o
                  preenchimento de seu endereço eletrônico pessoal e senha
                  criada na Base) ou qualquer quebra de segurança de seu
                  conhecimento. Concorda também em não deixar seu cadastro
                  pessoal aberto no computador após entrar com seu endereço
                  eletrônico e senha na Base, evitando, assim, o uso
                  desautorizado por terceiros.
                </p>
                <p>
                  3.8. Faz parte de nossa política respeitar a privacidade
                  de nossos Usuários. A Editora Senac não irá monitorar,
                  editar, acessar ou divulgar informações privativas de seus
                  Usuários, exceto nos casos expressamente previstos na
                  Cláusula de Privacidade abaixo ou a menos que a Editora
                  seja obrigada a fazê-lo mediante ordem judicial ou por
                  força de lei.
                </p>

                <h2>4. Conteúdos e/ou Anotações Realizados pelos Usuários</h2>
                <p>
                  4.1 Os conteúdos da Base permitem que os Usuários insiram
                  informações em ambientes dentro das páginas dos títulos da
                  Base (as “Anotações”), ficando os Usuários inteiramente
                  responsáveis pela inserção e pelo teor das Anotações.
                </p>
                <p>
                  4.2 Os conteúdos da Base possibilitam ao Usuário utilizar
                  o espaço virtual para a inserção de suas Anotações, não
                  sendo incumbência da Editora Senac São Paulo interferir na
                  elaboração e composição de qualquer Anotação inserida pelo
                  Usuário na Base, independentemente de sua natureza,
                  podendo a Editora, entretanto, encerrar a hospedagem de
                  qualquer Anotação, a seu exclusivo critério. A Editora se
                  exime de toda e qualquer responsabilidade, perante o
                  Usuário e terceiros, decorrente das Anotações inseridas
                  pelos Usuários, tendo em vista a impossibilidade técnica
                  de se efetuar monitoramento preventivo de todos as
                  Anotações inseridas por Usuários em sua Base
                </p>
                <p>
                  4.3 Os Usuários declaram e garantem expressamente que são
                  os únicos titulares de direitos patrimoniais de autor
                  incidentes sobre as Anotações, e pelo presente Termo
                  licenciam à Editora, de forma gratuita, em caráter
                  irrevogável e irretratável, por todo o período de proteção
                  legal do direito patrimonial de autor incidentes sobre as
                  Anotações, para o território do Brasil e o exterior, a
                  totalidade dos direitos patrimoniais de autor sobre as
                  Anotações de que são titulares, ficando a Editora, desta
                  forma, autorizada a utilizar e retransmitir as Anotações,
                  total ou parcialmente, bem como a distribuí-las,
                  traduzi-las, adaptá-las e veiculá-las por meio de seus
                  próprios canais de distribuição, tanto existentes quanto
                  os que venham a existir no futuro, inclusive por meio
                  eletromagnético, eletrônico e de telefonia ou por qualquer
                  outro meio que permita sua reprodução, difusão e
                  disponibilização, assim como por qualquer suporte material
                  que permita a sua multiplicação em exemplares, sem
                  restrição quanto ao número de reproduções, meios de
                  fixação, prazo, território e formas de utilização.
                </p>
                <p>
                  4.5 A Editora não se responsabiliza por realizar
                  armazenagem e backups das Anotações inseridas, veiculadas
                  ou geradas por Usuários na Base.
                </p>

                <h2>
                  5. Conteúdo baixado no Aplicativo (app)
                </h2>
                <p>
                  5.1 O download do Conteúdo exige que o Usuário instale em
                  seu dispositivo móvel um aplicativo por meio de canais de
                  terceiros (Android ou iOS).
                </p>
                <p>
                  5.2 A Editora não se responsabiliza pela instalação do
                  aplicativo por meio desses canais, assim como por nenhum
                  dano que ele possa acarretar ao equipamento.
                </p>
                <p>
                  5.3 Garantimos que o conteúdo, quando baixado de acordo
                  com a descrição fornecida pela Editora Senac São Paulo,
                  assim como quaisquer serviços que fornecermos por meio
                  dele, será oferecido com qualidade e excelência.
                </p>
                <p>
                  5.4 O Usuário e/ou “Clientes institucionais assinantes”
                  não têm permissão para:
                </p>
                <ul>
                  <li>
                    alugar, dar concessão, emprestar, vender, licenciar ou
                    transferir o acesso à Base ou ao Produto a qualquer
                    terceiro; explorar a Base ou o Produto para fins
                    comerciais; ou usar qualquer informação na Base ou em um
                    Produto (direta ou indiretamente) para lucro ou ganho;
                  </li>
                </ul>
                <ul>
                  <li>
                    copiar ou armazenar qualquer Produto ou Base (ou
                    qualquer parte deles) que não seja para seu próprio uso
                    pessoal e não comercial;
                  </li>
                </ul>
                <ul>
                  <li>
                    armazenar a Base ou qualquer Produto em um servidor ou
                    outro dispositivo de armazenamento conectado a uma rede
                    ou ainda criar um banco de dados;
                  </li>
                </ul>
                <ul>
                  <li>
                    interferir, perturbar, alterar, traduzir ou modificar a
                    Base, o Produto ou qualquer parte dele; criar um ônus
                    indevido na Base, no Produto ou nas redes ou serviços
                    conectados a eles; tentar contornar a segurança de
                    quaisquer servidores nos quais a Base ou o Produto
                    estejam hospedados;
                  </li>
                </ul>
                <ul>
                  <li>
                    fazer engenharia reversa, descompilar, desmontar ou
                    reverter a compilação da Base ou de qualquer Produto;
                  </li>
                </ul>
                <ul>
                  <li>
                    introduzir software ou agentes automatizados ou scripts
                    na Base ou no Produto para produzir várias contas, gerar
                    pesquisas, solicitações e consultas automatizadas ou
                    para remover, raspar ou minerar dados da Base ou do
                    Produto;
                  </li>
                </ul>
                <ul>
                  <li>
                    transmitir, distribuir, apresentar ou disponibilizar de
                    qualquer maneira por meio da Base ou do Produto vírus de
                    computador, keyloggers, spyware, worms, cavalos de
                    troia, bombas-relógio ou outra programação maliciosa ou
                    prejudicial, ou usar qualquer Produto da Base de uma
                    forma que possa prejudicar nosso nome ou reputação ou de
                    qualquer um dos nossos afiliados;
                  </li>
                </ul>
                <ul>
                  <li>
                    exportar qualquer Produto em violação das leis de
                    exportação ou importação aplicáveis de qualquer país;
                  </li>
                </ul>
                <ul>
                  <li>
                    exibir, executar, republicar ou reproduzir publicamente
                    qualquer Produto disponibilizado para download na Base
                    (incluindo, sem limitação, por meio de e-mail, grupos de
                    notícias, áreas de arquivo ou discussão, intranet ou
                    Base da Internet ou qualquer outro meio);
                  </li>
                </ul>
                <ul>
                  <li>
                    adulterar, ignorar ou alterar qualquer segurança,
                    gerenciamento de direitos digitais ou outros
                    procedimentos de execução de licenciamento relacionados
                    ao Produto, Base ou Serviços; ou, caso contrário, fazer
                    qualquer coisa que não seja expressamente permitida por
                    esses Termos.
                  </li>
                </ul>
                <p>
                  5.5 Todos os direitos concedidos ao Usuário sob estes
                  Termos serão rescindidos imediatamente no caso de violação
                  de qualquer um deles, sem prejuízo das ações serem levadas
                  a conhecimento das autoridades competentes, caso sejam
                  apenadas em no direito pátrio, e do responsável
                  sujeitar-se à reparação dos danos causados.
                </p>

                <h2>
                  6. Propriedade Intelectual
                </h2>
                <p>
                  6.1. A Editora Senac licencia qualquer Produto para
                  baixar, dentro do pacote de assinaturas, mas não o vende.
                  A Editora Senac, licenciadora de Conteúdo, permanece
                  proprietária de todos os Conteúdos em todos os momentos.
                </p>
                <p>
                  6.2. Os Usuários e/ou Clientes institucionais reconhecem
                  que não adquirem nenhum direito de propriedade fazendo o
                  download da Base, de qualquer Produto ou de qualquer
                  conteúdo dela.
                </p>
                <h2>7. Privacidade</h2>
                <p>
                  7.1. À medida que o Usuário acessar a Base e/ou seu
                  Conteúdo, podem ser registradas automaticamente
                  informações sobre quais páginas foram acessadas pelo
                  Usuário, qual é seu navegador, seu sistema operacional,
                  seu IP, entre outras informações técnicas.
                </p>
                <p>
                  7.2. Algumas páginas da Base e/ou seu Conteúdo também
                  podem armazenar cookies, que consistem em pequenos
                  arquivos instalados por Bases nos computadores quando o
                  navegador de internet é usado. Esses arquivos permitem
                  identificar se um mesmo aparelho já fez uma visita
                  anterior à Base e se o Usuário tem ou não Cadastro.
                </p>
                <p>
                  7.3. Quaisquer dados fornecidos pelos Usuários serão
                  armazenados, e a Editora Senac envidará os melhores
                  esforços na manutenção da confidencialidade, integridade e
                  disponibilidade das informações que forem fornecidas.
                </p>
                <p>
                  7.4. Todos os dados pessoais coletados dos Usuários serão
                  incorporados de forma temporária à Biblioteca Digital
                  Senac da Editora Senac São Paulo. A exclusão desses dados
                  é de responsabilidade dos “Clientes institucionais
                  assinantes”.
                </p>
                <p>
                  7.5. A editora Senac São Paulo poderá utilizar as
                  informações coletadas dos Usuários, inclusive por meio de
                  cookies, para disponibilizar estatísticas gerais, com ou
                  sem identificação do Usuário aos “Clientes institucionais
                  assinantes”.
                </p>
                <p>
                  7.6. As atividades mencionadas anteriormente dependem de
                  autorização expressa do Usuário, motivo pelo qual esta
                  autorização será solicitada no momento de seu Cadastro na
                  Base
                </p>
                <p>
                  7.7. O Usuário garante a veracidade e a exatidão dos dados
                  que fornece à Editora Senac São Paulo, a qual não tem
                  qualquer responsabilidade no caso de inserção de dados
                  falsos ou inexatidão dos dados pessoais informados pelo
                  Usuário.
                </p>
                <h2>
                  8. Violação das Condições de Uso da Biblioteca Digital
                  Senac
                </h2>
                <p>
                  8.1. No caso de o Usuário fazer uso dos Conteúdos da Base:
                </p>
                <ul>
                  <li>
                    contrariando lei ou norma da Administração Pública,
                    direta ou indireta;
                  </li>
                </ul>
                <ul>
                  <li>
                    qualquer uma das condições destes Termos de uso aqui
                    estipuladas;
                  </li>
                </ul>
                <ul>
                  <li>
                    haja suspeita de veiculação, transmissão ou
                    disponibilização pelo Usuário na Base de qualquer
                    material, informação ou conteúdo ilícito ou que atente
                    contra os direitos de terceiros, incluindo direitos de
                    propriedade intelectual.
                  </li>
                </ul>
                <p>
                  A Editora Senac se reserva ao direito de:
                </p>
                <ul>
                  <li>
                    suspender, no todo ou em parte, o acesso do Usuário às
                    funcionalidades da Base (podendo, inclusive, bloquear
                    IPs);
                  </li>
                </ul>
                <ul>
                  <li>
                    cancelar o Cadastro e/ou a conta de qualquer Usuário;
                  </li>
                </ul>
                <ul>
                  <li>
                    Informar às autoridades competentes fatos que configurem
                    crimes ou sejam apenados por sanções administrativas;
                  </li>
                </ul>
                <ul>
                  <li>
                    buscar a responsabilização cível ou criminal dos
                    usuários pelos danos causados.
                  </li>
                </ul>
                <h2>
                  9. Exclusão de Responsabilidades
                </h2>
                <p>
                  9.1. Em nenhuma hipótese a Editora Senac poderá ser
                  responsabilizada por quaisquer perdas e danos (incluindo,
                  mas não se limitando, os lucros cessantes, a interrupção
                  de negócios, as perdas de informações, as indenizações de
                  qualquer natureza, as despesas e outros prejuízos
                  pecuniários de qualquer natureza) resultantes de:
                </p>
                <ul>
                  <li>
                    problemas ocorridos na transmissão de dados,
                    informações, conteúdos, programas, indisponibilidade,
                    paradas totais ou parciais dos Conteúdos da Base;
                  </li>
                </ul>
                <ul>
                  <li>
                    eventos que se caracterizem como caso fortuito ou força
                    maior, assim entendidas as circunstâncias imprevisíveis
                    e inevitáveis que impeçam, total ou parcialmente, a
                    execução das obrigações assumidas;
                  </li>
                </ul>
                <ul>
                  <li>
                    eventos ocorridos que dependam de recursos e/ou serviços
                    de responsabilidade da Administração Pública, direta ou
                    indiretamente;
                  </li>
                </ul>
                <ul>
                  <li>
                    utilização indevida ou ilegal, por terceiros e/ou pelos
                    Usuários, das funcionalidades disponibilizados na Base;
                  </li>
                </ul>
                <ul>
                  <li>
                    violação, pelo Usuário e por terceiros, de propriedade
                    intelectual, de material protegido por direito autoral e
                    software e de material protegido por direito industrial;
                  </li>
                </ul>
                <ul>
                  <li>impossibilidade de acesso à Base;</li>
                </ul>
                <ul>
                  <li>
                    incompatibilidade de equipamentos e sistemas utilizados
                    pelo Usuário com as funcionalidades e sistemas da Base;
                  </li>
                </ul>
                <ul>
                  <li>
                    por qualquer dano ou prejuízo decorrentes de vírus e/ou
                    programas de computador nocivos de qualquer natureza ou
                    outros programas, conforme previsto neste instrumento,
                    que possam contaminar os equipamentos do Usuário e/ou
                    afetar seu acesso aos conteúdos e às funcionalidades da
                    Base;
                  </li>
                </ul>
                <ul>
                  <li>
                    aplicativos e sistemas cuja instalação não seja
                    expressamente permitida por Usuários e tenham como
                    finalidades espionagem, roubo e coleta de dados não
                    autorizados, entre outros;
                  </li>
                </ul>
                <ul>
                  <li>
                    manutenções técnicas e/ou operacionais que exijam o
                    desligamento temporário do sistema ou impossibilitem o
                    acesso à Base e suas funcionalidades;
                  </li>
                </ul>
                <ul>
                  <li>
                    uso ou impossibilidade de uso da informação e conteúdos
                    transmitidos, disponibilizados, armazenados, hospedados
                    e/ou veiculados na Base, ou de qualquer decisão tomada
                    pelo Usuário e/ou qualquer terceiro com base nas
                    funcionalidades disponibilizadas na Base;
                  </li>
                </ul>
                <ul>
                  <li>
                    pelas condutas adotadas pelos Usuários na utilização das
                    funcionalidades disponibilizadas na Base;
                  </li>
                </ul>
                <ul>
                  <li>danos causados por terceiros ao Usuário;</li>
                </ul>
                <ul>
                  <li>
                    ações de terceiros que impeçam a disponibilização da
                    Base;
                  </li>
                </ul>
                <ul>
                  <li>
                    qualquer tipo de evento que esteja fora do controle da
                    Editora Senac;
                  </li>
                </ul>
                <ul>
                  <li>
                    por descumprimento pelo Usuário ou terceiros da
                    legislação em vigor; destes Termos de Uso; dos usos e
                    costumes aplicáveis à internet e de quaisquer outras
                    Regras de Utilização descritas na Base;
                  </li>
                </ul>
                <ul>
                  <li>
                    por informações, conteúdos, produtos e serviços de
                    terceiros disponíveis em Bases ou páginas de terceiros
                    acessadas por meio de links e hiperlinks inseridos nas
                    páginas dos títulos da Base.
                  </li>
                </ul>
                <h2>
                  10. Inexistência de Vínculo
                </h2>
                <p>
                  10.1. O presente instrumento e as obrigações e direitos
                  aqui previstos não importam na criação de qualquer vínculo
                  trabalhista, societário, de parceria ou associativo entre
                  o Usuário e a Editora Senac São Paulo, sendo excluídas
                  quaisquer presunções de solidariedade entre ambos no
                  cumprimento de suas obrigações.
                </p>
                <h2>
                  11. Eventos de Caso Fortuito e Força Maior
                </h2>
                <p>
                  11.1. A Editora Senac se exime de qualquer
                  responsabilidade decorrente de eventos de caso fortuito ou
                  força maior, assim entendidas as circunstâncias
                  imprevisíveis e inevitáveis que impeçam, total ou
                  parcialmente, a execução das obrigações assumidas.
                </p>
                <h2>Contato</h2>
                <p>
                  Se você tiver dúvidas, comentários ou solicitações sobre
                  esses Termos, por favor entre em contato conosco:
                </p>
                <p>
                  e-mail: bibliotecadigital@sp.senac.br
                </p>
              </div>
            </div>
          </div>
          <Footer/>
        </div>
      </div>
    );
  }
}